// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ainj","imageUploader":"EGiftCard_imageUploader__HMyMa"};